import { FC } from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { SECTION_PADDING } from '../../styles/theme';
import SectionTitle from '../section-title';
import ArticleCard, { ArticleCardProps } from './ArticleCard';
import Slider from 'react-slick';
import { ARTICLES } from '../../const/ARTICLES';

const ArticleSection: FC = () => {
  const theme = useTheme();
  const useSlide = useMediaQuery(theme.breakpoints.down('sm'));

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
  };

  const fullWidthArticle = ARTICLES[0];
  const leftArticles = ARTICLES.slice(1);
  return (
    <Box
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        display: {
          xs: 'auto',
          sm: 'auto',
          md: 'flex',
        },
        py: SECTION_PADDING.py,
        px: { xs: '0px', sm: SECTION_PADDING.px.sm, md: SECTION_PADDING.px.md },
      }}
    >
      <Box
        sx={{
          maxWidth: '1440px',
          justifyContent: 'center',
          alignItems: 'stretch',
          marginX: '0',
        }}
      >
        <Box
          sx={{
            marginBottom: {
              xs: '70px',
              sm: '70px',
              md: '70px',
            },
            paddingX: {
              xs: '24px',
              sm: 'auto',
            },
          }}
        >
          <SectionTitle
            title={'Read about our'}
            subtitle={'Latest Industry Insights'}
            align={'left'}
          />
        </Box>
        <Box
          sx={{
            width: { sx: 'calc(100vw - 48px)', sm: 'auto' },
            maxWidth: { sx: 'calc(100vw - 48px)', sm: 'auto' },
            minWidth: { sx: 'calc(100vw - 48px)', sm: 'auto' },
            paddingX: { xs: '24px', sm: '0px' },
            marginBottom: '70px',
          }}
        >
          <ArticleCard {...fullWidthArticle} fullWidth={true} />
        </Box>
        {useSlide && (
          <Slider {...sliderSettings}>
            {leftArticles.map((feature, index) => (
              <Box
                sx={{
                  width: 'calc(100vw - 56px)',
                  maxWidth: 'calc(100vw - 56px)',
                  minWidth: 'calc(100vw - 56px)',
                  paddingLeft: '24px',
                }}
                key={index}
              >
                <ArticleCard {...feature} />
              </Box>
            ))}
          </Slider>
        )}
        {!useSlide && (
          <Grid
            container
            spacing={{ xs: 2, md: '24px' }}
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {leftArticles.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <ArticleCard {...feature} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default ArticleSection;
